var _path, _g, _path2, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_10760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00391 6.25146H20.0025V24.4056H3.00391V6.25146Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_10760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5965 6.3194H11.5712C11.442 13.9282 10.3948 15.1131 3.03027 15.2785V15.3208C10.4351 15.4871 11.4532 16.685 11.573 24.4056H11.5948C11.7136 16.7347 12.7197 15.5027 19.9954 15.3241V15.2752C12.7594 15.0975 11.7245 13.8787 11.5965 6.3194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_122_10760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.451843H9.62997V10.7718H0V0.451843Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_122_10760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84363 0.507324H4.82951C4.75653 4.80046 4.16568 5.46929 0.0102539 5.56257V5.5864C4.18833 5.68027 4.76301 6.35616 4.83039 10.7123H4.84245C4.90984 6.38412 5.47745 5.68909 9.58255 5.58817V5.56051C5.49981 5.46046 4.91602 4.7725 4.84363 0.507324Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1132 5.24078H17.1055C17.0667 7.54242 16.7498 7.90082 14.522 7.95084V7.96349C16.7618 8.01411 17.0699 8.37633 17.1061 10.7118H17.1126C17.1485 8.39134 17.453 8.01852 19.6537 7.96467V7.94966C17.4648 7.89611 17.1517 7.52741 17.1132 5.24078Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3297 0H12.325C12.3009 1.4127 12.1066 1.6328 10.7393 1.6634V1.67135C12.114 1.70225 12.3029 1.92441 12.3253 3.358H12.3294C12.3512 1.93382 12.5383 1.70489 13.8889 1.67164V1.66282C12.5457 1.62986 12.3535 1.40358 12.3297 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/Magic.31146d0118dd05d1c38cf2dfffcd5c79.svg";
export { ForwardRef as ReactComponent };